import React from "react";
import "../styles/stats.css";

export default function Stats() {
  const stats = [
    {
      value: "99.5% ",
      title: "Accuracy Achieved",
      desc: "Shows superiority over manual processes.",
    },
    {
      value: "99.99%",
      title: "System Uptime Guarantee",
      desc: "Enterprise-grade reliability designed for mission-critical operations.",
    },
    {
      value: "40%",
      title: "Downtime Reduced",
      desc: "Shows direct business value.",
    },
    {
      value: "300+",
      title: "Industries Served",
      desc: "Transparent Device you can trust – every decision is traceable.",
    },
  ];

  return (
    <section className="about">
      <div className="about-left">
        {/* <button className="about-tag">Flovation Stats</button> */}
        <h2>
          Simplifying the Future with <br />
          <span> Smart Technologies</span>
        </h2>
        <p>
          With SuperManager, we’re shaping a connected future — where machines communicate, 
          data drives intelligence, and innovation powers progress. Through our IoT platform, 
          we transform industries and elevate human efficiency across every touchpoint
        </p>
        <button className="about-btn">About Us</button>
      </div>

      <div className="about-right">
        {stats.map((item, index) => (
          <div className="stat-card" key={index}>
            <h3>{item.value}</h3>
            <h4>{item.title}</h4>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
